import { Reducer } from 'redux'

import { IRequestCourseState } from 'store/states/requestOutsideCourses.state'
import { IRequestCourseModel } from 'models/requestCourse.model'
import * as fromActions from '../actions/requestOutsideCourses.action'

export const initialState: IRequestCourseState = {
  admin: [],
  supervisor: [],
  loading: false,
}

type ListSuccess = {
  type:
    | typeof fromActions.REQUEST_OUTSIDE_COURSES_GET_LIST_SUPERVISOR_SUCCESS
    | typeof fromActions.REQUEST_OUTSIDE_COURSES_GET_LIST_ADMIN_SUCCESS
  payload: {
    data: IRequestCourseModel[]
  }
}

type Loading = {
  type:
    | typeof fromActions.REQUEST_OUTSIDE_COURSES_GET_LIST_SUPERVISOR
    | typeof fromActions.REQUEST_OUTSIDE_COURSES_GET_LIST_ADMIN
    | typeof fromActions.REQUEST_OUTSIDE_COURSES_LOADING
  payload: {
    loading: boolean
  }
}

export type ReducerActions = ListSuccess | Loading

export const reducer: Reducer<IRequestCourseState, ReducerActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case fromActions.REQUEST_OUTSIDE_COURSES_GET_LIST_SUPERVISOR:
    case fromActions.REQUEST_OUTSIDE_COURSES_GET_LIST_ADMIN:
      return {
        ...state,
        loading: true,
      }
    case fromActions.REQUEST_OUTSIDE_COURSES_GET_LIST_ADMIN_SUCCESS: {
      const { data } = action.payload
      return {
        ...state,
        admin: data,
        loading: false,
      }
    }
    case fromActions.REQUEST_OUTSIDE_COURSES_GET_LIST_SUPERVISOR_SUCCESS: {
      const { data } = action.payload
      return {
        ...state,
        supervisor: data,
        loading: false,
      }
    }
    case fromActions.REQUEST_OUTSIDE_COURSES_LOADING: {
      const { loading } = action.payload
      return {
        ...state,
        loading,
      }
    }

    default:
      return state
  }
}
